export default __webpack_public_path__ + "40cba689761538f78984b1cd0528c935.png";